export default class AjaxStatusCore {

	/**
	 * @param callback a generic quick easy callback adder for any status change. use registerChangedCallback() for adding more or ajaxId specific callbacks
	 */
	constructor(callback) {
		// unique id for each callback allowing them to be unregistered
		this.callbackId = 1;
		this.data = {
			// id/count for each ajax statement
			ajaxStatus: {},
			changedCallbacks: [],
		};
		if (callback) {
			this.registerChangedCallback(callback);
		}
	}

	/**
	 * check if currently in the middle of an ajax request
	 *
	 * @param ajaxId undefined for any ajax call; or the particular ajaxId to check
	 * @return boolean true if the ajaxId, or any ajaxIds if no ajaxId provided, is currently ajaxing
	 */
	isAjaxing(ajaxId = undefined) {
		return ajaxId ? !!this.data.ajaxStatus[ajaxId] : Object.keys(this.data.ajaxStatus).reduce((status, key) => status || (!!this.data.ajaxStatus[key]), false);
	}

	/**
	 * an ajax call is starting or ending being called so update ajax count
	 *
	 * @param ajaxId undefined for any ajax; or the particular ajaxId to check
	 * @param isAjaxStarting boolean true means a request is being started, false means a request returned
	 */
	changeAjaxing(ajaxId, isAjaxStarting) {
		const useAjaxId = ajaxId || 'someAnonymousAjaxCall';
		this.data.ajaxStatus[useAjaxId] = (this.data.ajaxStatus[useAjaxId] || 0) + (isAjaxStarting ? 1 : -1);

		// check for any callbacks for the given ajaxId (ajaxId may be undefined if for ANY ajax call)
		this.data.changedCallbacks.forEach(callbackObj => (callbackObj.ajaxId === ajaxId || !callbackObj.ajaxId) ? callbackObj.callback(ajaxId, isAjaxStarting) : undefined);
	}

	/**
	 * MAKE SURE TO CALL unregisterChangedCallback() WHEN
	 * provide a callback for whenever the ajax state changes: (ajaxId, isAjaxingState) => {whatever you want to do in your callback}
	 *
	 * @param callback (ajaxId, isAjaxingStarting) => {whatever you want to do when ajaxes are stopped or started}; note that isAjaxStarting tells if the call is starting or stopping but not whether the ajaxId is currently still ajaxing (multiples with the same ajaxId at the same time)
	 * @param ajaxId the ajaxId that was called to trigger the change
	 * @return id for later unregistering the callback
	 */
	registerChangedCallback(callback, ajaxId) {
		const callbackId = this.callbackId++;
		this.data.changedCallbacks.push({ajaxId: ajaxId, callback: callback, callbackId: callbackId});
		return callbackId;
	}

	/**
	 * unregister for listening to a callback
	 *
	 * @param callbackId the id returned from registerChangedCallback
	 */
	unregisterChangedCallback(callbackId) {
		this.data.changedCallbacks = this.data.changedCallbacks.filter(cb => cb.callbackId !== callbackId);
	}
}